export default {"src":"/_next/static/media/apple-pay-logo.d66db965.svg","height":63,"width":98,"blurWidth":0,"blurHeight":0};